import * as React from "react";
import { ISectionElement } from "@graffer-inc/form-schema";
import {
  SectionTemplateProps,
  SectionTemplateRegistry,
} from "@graffer-inc/form-generator";
import { DefaultSectionTemplateRegistry } from "@graffer-inc/form-generator";

export const ConfirmSectionTemplate: React.FC<{
  section: ISectionElement;
  children?: React.ReactNode;
}> = ({ section, children }) => {
  return (
    <div
      key={section.id}
      style={{
        marginBottom: "24px",
      }}
    >
      <p
        className="title is-size-4 mt-4 mb-4 pl-2"
        style={{
          borderLeft: "6px solid #40bfb0",
        }}
      >
        {section.title}
      </p>
      {children}
    </div>
  );
};

export class SmartApplyConfirmSectionTemplateRegistry
  implements SectionTemplateRegistry
{
  get(type: ISectionElement): React.ComponentType<SectionTemplateProps> {
    return DefaultSectionTemplateRegistry.get(type);
  }

  getSectionWrapper(_: ISectionElement): React.ComponentType<{
    children?: React.ReactNode;
    section: ISectionElement;
  }> {
    return ConfirmSectionTemplate;
  }
}
